<template>
  <div id="CustomerContracts">
    <div class="mb-3">
      <a class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="GoToDetailContract" title="افزودن قرارداد جدید">
        <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
      </a>
    </div>
    <BnpGrid v-if="$store.state.renderComponent" :hasRowNum="true" :SumList="$IsAccess('colContractAmount') ? ['TotallAmount', 'TollTax', 'Tax', 'Discount', 'Amount'] : false" :propsColumn="Column" :propsRows="ContractList" :action="true" :Sortable="true" :pagenum="50">
      <!-- <template slot="IsApproval" slot-scope="props">
        
      </template> -->
      <template slot="action-slot" slot-scope="props">
        <span v-if="props.props.IsApproval == false">
          <a href="javascript:;" class="mr-2 badge" @click="OnApproval(props.props)" v-if="$session.get('Menu').filter((x) => x.RouteName == 'CartableContract')[0].isMojaz == 1" data-title="تایید قرارداد">
            <h6><span class="fas fa-certificate text-secondary hover-warning" style="font-size: 20px"></span></h6>
          </a>
        </span>
        <i v-else title="تایید شده توسط مدیر" style="font-size: 20px" class="fas mt-2 mr-2 fa-check-circle-o text-success ml-3"></i>

        <!-- <span class="ml-3" style="font-size: 15px" v-if="($session.get('Menu').filter((x) => x.TblCloudMenuId == 122)[0].isMojaz == 1 && (props.props.DocNumber == null || props.props.DocNumber == 0) && props.props.IsApproval == false) || $session.get('UserInfo').tblGrpId == 1 || $session.get('UserInfo').tblUserId==205245">
          <i class="fas fa-marker text-secondary hover-warning Pointer" @click="OnEditProduct(props.props)"></i>
        </span> -->
      </template>
      <template slot="TotallAmount" slot-scope="props">
        <span v-if="$IsAccess('colContractTotal')">{{ $Comma3ragham(props.props.TotallAmount) }}</span>
        <span v-else> ****** </span>
      </template>
      <template slot="Amount" slot-scope="props">
        <span v-if="$IsAccess('colContractAmount')">{{ $Comma3ragham(Math.floor(props.props.Amount)) }}</span>
        <span v-else> ****** </span>
      </template>
      <template slot="TollTax" slot-scope="props">
        <span v-if="$IsAccess('colContractTax') && $IsAccess('colContractToll')">{{ $Comma3ragham(Math.floor(props.props.TollTax)) }}</span>
      </template>
      <template slot="Discount" slot-scope="props">
        <span v-if="$IsAccess('colContractDiscount')">{{ $Comma3ragham(Math.floor(props.props.Discount)) }}</span>
        <span v-else> ****** </span>
      </template>
      <template slot="tblComboGrp12Name" slot-scope="props">
        <span v-if="$IsAccess('colContractType')">{{ props.props.tblComboGrp12Name }}</span>
        <span v-else> ****** </span>
      </template>
      <template slot="TblContractId" slot-scope="props">
        <span>{{ props.props.TblContractId }} #</span>
      </template>
      <template slot="tblComboGrpId39" slot-scope="props">
        <SearchableCombo
          v-if="$store.state.renderComponent && $store.state.renderComponentSort"
          :edit="false"
          :grp="39"
          :code="null"
          @ResultCombo="GetResultVaziat"
          :rownumintable="3"
          :defaultvalue="props.props.tblComboGrpId39"
          :disabled="$session.get('Menu').filter((x) => x.ControlName == 'dmnuChangeStatusContract')[0].isMojaz == 0"
          :action="'TblCrmCombo/GetComboById'"
          :method="'POST'"
          :idinput="'Vaziat' + props.props.id"
          :keyItem="'Vaziat' + props.props.id"
        >
        </SearchableCombo>
      </template>
      <template slot="Rate" slot-scope="props">
        <span v-if="$session.get('Menu').filter((x) => x.ControlName == 'submitRate')[0].isMojaz == 1">
          <input type="text" dir="ltr" class="form-control text-left w-100 3ragham" @keyup="props.props.Rate = $PutCommatoInput_New($event)" @keydown="submitRate(props.props, $event)" style="font-size: smaller!" :id="'input' + props.props.id" v-model="props.props.Rate" />
          <!-- <div class="col-12 text-center mt-1 p-0">
              <a @click="submitRate(props.props)" :data-title="'ثبت نرخ تمدید'" class="badge badge-primary"><i class="fas fa-check"></i></a>
            </div> -->
        </span>
        <span v-if="$session.get('Menu').filter((x) => x.ControlName == 'viewRate')[0].isMojaz == 1"> {{ $Comma3ragham(Number(props.props.Rate == null ? 0 : props.props.Rate)) }} </span>
      </template>
    </BnpGrid>

    <!-- مدال ویرایش محصول -->
    <modal v-if="$store.state.Modal && MODAL" :InheritanceTheme="true" :IsFooter="false" :Size="'Md'">
      <template v-slot:body>
        <div class="p-4" id="DetailCustomerProductEdit">
          <div class="row">
            <div class="col-12 mb-3">
              <h3 style="color: var(--sidebar-color-item) !important">
                {{ NameProductForEdit }}
              </h3>
            </div>
            <div class="col-md-4 col-12">
              <small id="LblCount">تعداد</small>
              <input dir="ltr" type="number" @keypress="$ValidNumber($event, 2)" @input="FocusOutAmountProductEdit($event)" class="form-control" id="txtCount" v-model="DataAxiosEditProduct.Count" tabindex="1" />
            </div>

            <div class="col-md-4 col-12">
              <small id="LblAmount">مبلغ</small>
              <input
                dir="ltr"
                type="text"
                @keypress="$ValidNumber($event, 15)"
                @input="FocusOutAmountProductEdit($event)"
                @keyup="DataAxiosEditProduct.Amount = $PutCommatoInput_New($event)"
                class="form-control InputText 3ragham required"
                id="txtAmount"
                v-model="DataAxiosEditProduct.Amount"
                tabindex="2"
              />
            </div>
            <div class="col-md-4 col-12">
              <small id="LblDiscount">مبلغ تخفیف</small>
              <input
                dir="ltr"
                type="text"
                @keypress="$ValidNumber($event, 15)"
                @keyup="DataAxiosEditProduct.Discount = $PutCommatoInput_New($event)"
                @input="FocusOutAmountProductEdit($event)"
                class="form-control InputText 3ragham required"
                id="txtDiscount"
                v-model="DataAxiosEditProduct.Discount"
                tabindex="3"
              />
            </div>
            <div class="col-md-4 col-12 mt-2">
              <small id="LblTax">مبلغ مالیات </small>

              <input dir="ltr" type="text" @keypress="$ValidNumber($event, 15)" @keyup="DataAxiosEditProduct.Tax = $PutCommatoInput_New($event)" class="form-control 3ragham" id="txtTax" v-model="DataAxiosEditProduct.Tax" tabindex="4" disabled />
            </div>
            <div class="col-md-4 col-12 mt-2">
              <small id="LblToll">مبلغ عوارض </small>
              <input dir="ltr" type="text" @keypress="$ValidNumber($event, 15)" @keyup="DataAxiosEditProduct.Toll = $PutCommatoInput_New($event)" class="form-control 3ragham" id="txtToll" v-model="DataAxiosEditProduct.Toll" tabindex="5" disabled />
            </div>

            <div class="col-md-4 col-12 mt-2">
              <small id="LblNeedSubmit">نیاز به تمدید</small>
              <span class="form-control p-1">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input InputText" id="NeedSubmit" v-model="DataAxiosEditProduct.NeedSubmit" />
                  <label class="custom-control-label mr-2" for="NeedSubmit"> نیاز به تمدید </label>
                </div>
              </span>
            </div>

            <div class="col-md-4 col-12 mt-2">
              <small id="LblTotallAmount">مبلغ کل </small>
              <input dir="ltr" type="text" class="form-control" id="txtTotallAmount" v-model="DataAxiosEditProduct.TotallAmount" tabindex="5" disabled />
            </div>

            <div class="col-md-4 col-12">
              <button class="btn btn-primary w-100" v-if="ErrList.length == 0" @click.prevent="EditRow()" style="margin-top: 28px">ویرایش اطلاعات</button>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer> </template>
    </modal>
  </div>
</template>
<script>
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import { error } from 'highcharts'
import Modal from '../../../Modal/Modal.vue'

export default {
  components: { BnpGrid, SearchableCombo, Modal },
  data() {
    return {
      ErrList: [],
      tarix: [],
      Rows: [],
      Column: [
        { id: 2416, name: 'TblContractId', visibility: true, label: 'شماره قرارداد ' },
        { id: 2416, name: 'DocNumber', visibility: true, label: 'ش ف ' },
        { id: 2416, name: 'ProductName', visibility: true, label: 'نام محصول' },
        { id: 2416, name: 'tblComboGrp12Name', visibility: true, label: 'نوع قرارداد ' },
        { id: 2416, name: 'Amount', visibility: true, label: 'مبلغ ' },
        { id: 2416, name: 'Count', visibility: true, label: 'تعداد ' },
        { id: 2416, name: 'Discount', visibility: true, label: 'تخفیف ' },
        { id: 2416, name: 'TollTax', visibility: true, label: 'مالیات و عوارض ' },
        { id: 2416, name: 'Toll', visibility: false, label: ' عوارض' },
        { id: 2416, name: 'TotallAmount', visibility: true, label: ' جمع کل' },
        { id: 2416, name: 'ContractStartDate', visibility: true, label: ' شروع قرارداد' },
        { id: 2416, name: 'ContractEndDate', visibility: true, label: ' پایان قراداد' },
        { id: 2416, name: 'NeedSubmit', visibility: false, label: 'نیاز به تمدید' },
        { id: 2416, name: 'tblComboGrpId39', visibility: true, label: 'وضعیت' },
        { id: 2416, name: 'Rate', visibility: this.$session.get('Menu').filter((x) => x.ControlName == 'submitRate')[0].isMojaz == 1 || this.$session.get('Menu').filter((x) => x.ControlName == 'viewRate')[0].isMojaz == 1, label: 'نرخ تمدید' },
        // { id: 2416, name: 'IsApproval', visibility: true, label: 'تایید مدیر' },
      ],
      DataAxios_GetData: {
        ArryfildValue: {},
        Method: 'post',
        Action: 'Contract' + '/Index',
        Token: this.$session.get('Token'),
      },
      DataAxoisCol: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: 'frmContract',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      DataAxiosEditProduct: {},
      NameProductForEdit: '',
      MODAL: false,
    }
  },
  methods: {
    Search() {
      var row = {}
      this.Rows = []

      row.TaskDateAz = this.tarix.length > 0 ? this.tarix[0] : null
      row.TaskDateTa = this.tarix.length > 1 ? this.tarix[1] : null
      row.tblCustomerId = this.CustomerId
      row.TblComboGrpId12 = 2000
      this.DataAxios_GetData.ArryfildValue = row
      this.$PostData(this.DataAxios_GetData)
        .then((data) => {
          if (data.length > 0 && data[0].Id != null) {
            this.add = true
            for (let index = 0; index < data.length; index++) {
              this.Rows.push(data[index])
            }
          } else {
            this.Rows = []
            this.add = false
          }
        })
        .finally(() => {
          this.loadingRender = false
          this.$store.state.renderComponent = false
          this.$nextTick(() => {
            this.$store.state.renderComponent = true
          })
        })
    },
    Getcolumn() {
      this.$GetColumns(this.DataAxoisCol, true)
        .then((data) => {
          this.Column = data
        })
        .finally(() => {
          this.$store.state.renderComponent = false
          this.$nextTick(() => {
            this.$store.state.renderComponent = true
          })
        })
    },
    OnDetailProduct(row) {
      this.$router.push({ name: 'DetailContract', params: { Status: 'Product', TblContract: row } })
    },
    ChangeNeedSubmit(row) {
      this.$SweetQustion('تغییر وضعیت', 'از تغییر وضعیت محصول به حالت عدم تمدید اطمینان دارید؟', 'info', 'بلــه ', 'خیر', row, this.ChNeedSubmit, this.cancel)
      // console.log(row)
    },
    GetResultVaziat(data) {
      if (data.id != null && !data.IsDefault) {
        var DataAxios = { Method: 'POST', Action: 'Contract/updategrp39', ArryfildValue: { cpId: Number(data.key.replace('Vaziat', '')), comboId: data.id } }
        this.$PostData(DataAxios).then((result) => {
          if ((result.status = 'success')) {
            this.$toasted.success('وضعیت با موفقیت تغییر کرد', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
            this.$emit('Inserted', {
              done: 'OK',
              activeTab: 9,
            })
          } else {
            this.$toasted.error('خطا در تغییر وضعیت', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
          }
        })
      }
    },
    submitRate(data, e) {
      if (e.which == 13) {
        e.prevent
        var DataAxiosSubmitRate = { Method: 'POST', Action: 'Contract/SetRate', ArryfildValue: { Id: data.id, Usergrp: this.$session.get('UserInfo').tblUserGrpId, Rate: Number(data.Rate.replace(/,/g, '').replace(/\./g, '')) } }
        this.$PostData(DataAxiosSubmitRate)
          .then((result) => {
            if (result.status == 'success') {
              this.$toasted.success('نرخ تمدید به روز شد', {})
              this.$emit('Inserted', {
                done: 'OK',
                activeTab: 9,
              })
            } else {
              this.$toasted.error('نرخ تمدید به روز نشد. دوباره تلاش کنید', {})
            }
          })
          .catch((error) => {
            this.$toasted.error('نرخ تمدید به روز نشد. دوباره تلاش کنید', {})
          })
      }
    },
    OnApproval(row) {
      this.$SweetQustion('تایید قرارداد', 'از تایید قرارداد انتخابی اطمینان دارید؟؟', 'warning', 'تایید  قرارداد', 'انصراف', row, this.Success, this.Cancel)
    },
    Success(row) {
      this.$store.state.OldDataForLog = JSON.stringify(row)
      let DataAxios_DeleteData = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'Contract/ApprovalCartableContract',
        Token: this.$session.get('Token'),
      }
      DataAxios_DeleteData.ArryfildValue = { tblUserIdEdit: this.$session.get('UserInfo').tblUserId, Id: row.TblContractId }
      this.$PostData(DataAxios_DeleteData)
        .then((data) => {
          if (data.status == 'Ok') {
            this.$mySweetDefaultTost('عملیات موفق', 'مجوز این قرارداده اعمال شد', 'success', 2000)
            this.$emit('Inserted', {
              done: 'OK',
              activeTab: 9,
            })
            row.IsApproval = true
            this.$SetLog(row, 0, 1, 'CustomerContract', 'تب قرارداد')
            this.$toasted.success(' قرارداد تایید مدیر شد  ', { duration: 2000 })
            this.$store.state.renderComponent = false
            this.$nextTick(() => {
              this.$store.state.renderComponent = true
            })
          } else {
            if (data.eNum == 547) {
              this.$mySweetDefaultTost('عملیات ناموفق', 'امکان ثبت قرارداد وجود ندارد ، قرارداد شما داری محصول می باشد. ابتدا محصولات قرارداد رو حذف نمایید', 'warning', 5000)
            }
            // console.log(data)
          }
        })
        .finally(() => {})
    },
    Cancel() {},
    GoToDetailContract() {
      this.$router.push({ name: 'DetailContract', params: { TblCustomerId: this.CustomerId, Status: 'Add' } })
    },
    OnEditProduct(row) {
      this.NameProductForEdit = row.ProductName
      this.DataAxiosEditProduct.Id = row.Id
      this.DataAxiosEditProduct.Count = row.Count
      this.DataAxiosEditProduct.Amount = this.$Comma3ragham(row.Amount)
      this.DataAxiosEditProduct.Discount = this.$Comma3ragham(row.Discount)
      this.DataAxiosEditProduct.Tax = this.$Comma3ragham(row.Tax)
      this.DataAxiosEditProduct.TotallAmount = this.$Comma3ragham(row.TotallAmount)
      this.DataAxiosEditProduct.Toll = this.$Comma3ragham(row.Toll)
      this.DataAxiosEditProduct.NeedSubmit = row.NeedSubmit
      this.DataAxiosEditProduct.TblContractId = row.TblContractId

      this.$store.state.Modal = true
      this.MODAL = true
      let find = this.Rows.find((x) => x.Id == row.Id)
      // console.log(find)
      this.$store.state.OldDataForLog = JSON.stringify(find)
    },
    EditRow() {
      if (this.$ValidForm('DetailCustomerProductEdit')) {
        this.DataAxiosEditProduct.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
        let DataAxios_DeleteData = {
          ArryfildValue: this.DataAxiosEditProduct,
          Method: 'post',
          Action: 'CustomerProduct/EditProductOfContract',
        }
        this.$PostData(DataAxios_DeleteData)
          .then((data) => {
            if (data.status == 'Ok') {
              this.$store.state.Modal = false
              this.MODAL = false
              this.$mySweetDefaultTost('عملیات موفق', 'ویرایش با موفقیت انجام شد', 'success', 2000)
              this.$SetLog(this.DataAxiosEditProduct, 0, 0, 'CustomerProduct', 'محصولات قرارداد')
            } else {
              this.$mySweetDefaultTost('', 'ویرایش با مشکل مواجه شد', 'info', 2000)
            }
          })
          .catch((err) => {
            console.error('CATCH', err)
            if (userIdInsert == this.userId) {
              this.$mySweetDefaultTost('عملیات ناموفق', 'ارسال پیام با خطا مواجه شد', 'error', 2000)
              this.isSendingMesssage = false
            }
          })
          .finally(() => {
            this.$emit('Inserted', {
              done: 'OK',
              activeTab: 9,
            })
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          })
      }
    },
    FocusOutAmountProductEdit(e) {
      let amount = String(this.DataAxiosEditProduct.Amount)
      var AmountProduct = Number(amount.replace(/,/g, '').replace(/\./g, ''))
      //console.log('😎 ~ FocusOutAmountProductEdit ~ AmountProduct:', AmountProduct)
      let discount = String(this.DataAxiosEditProduct.Discount)
      var DiscountProduct = Number(discount != '0' ? discount.replace(/,/g, '').replace(/\./g, '') : 0)
      if (DiscountProduct > AmountProduct * this.DataAxiosEditProduct.Count) {
        this.$mySweetDefault('خطای عملیاتی', 'مبلغ تخفیف نمیتواند بیشتر از مبلغ محصول باشد', 'warning', 1500)
        this.ErrList = ['مبلغ تخفیف وارد شده بیشتر از حد مجاز می باشد ، لطفا اصلاح نمایید و دوباره تلاش کنید']
        this.$PutCommatoInput()
        this.DataAxiosEditProduct.Discount = this.$Comma3ragham(AmountProduct * this.DataAxiosEditProduct.Count)
        return
      } else {
        this.ErrList = []
        var mabKol = AmountProduct * Number(this.DataAxiosEditProduct.Count) - DiscountProduct
        this.DataAxiosEditProduct.Tax = mabKol == 0 ? '0' : this.$Comma3ragham(Math.ceil(Number(mabKol) * 0.07))
        this.DataAxiosEditProduct.Toll = mabKol == 0 ? '0' : this.$Comma3ragham(Math.ceil(Number(mabKol) * 0.03))
        this.DataAxiosEditProduct.TotallAmount = this.$Comma3ragham(mabKol + Number(this.DataAxiosEditProduct.Tax.replace(/,/g, '').replace(/\./g, '')) + Number(this.DataAxiosEditProduct.Toll.replace(/,/g, '').replace(/\./g, '')))
      }
    },
  },
  mounted() {
    // this.Getcolumn();
    this.Search()
    this.$GetAccessUser()
    console.warn(this.ContractList)
    this.ContractList.forEach((element) => {
      element['TollTax'] = element.Tax + element.Toll
    })
  },
  props: ['CustomerId', 'ContractList'],
}
</script>
<style>
#CustomerContracts table {
  font-size: smaller;
}
#CustomerContracts table input {
  font-size: x-small !important;
}
#CustomerContracts table td {
  padding-right: 1px !important;
  padding-left: 1px !important;
}
</style>
